<template>
    <div v-if="options && isLoginVisible" class="form">
        <div class="item" @keydown.enter.prevent.stop="submitForm()">
            <fieldset class="fieldset mrg" data-mrgt="20" :disabled="isLoading">
                <div class="form-items cf">
                    <div class="item">
                        <div class="control">
                            <label class="label" for="UserName">{{ localizer.get("Account.Common.UserName") }}</label>
                            <input type="text" id="UserName" v-model.lazy="formData.userName" autocomplete="email" :class="[{ 'input-validation-error': isValidationError('UserName') }, 'textbox short']" />
                            <span class="valid-sign">*</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="control" data-type="password">
                            <label class="label" for="Password">{{ localizer.get("Account.Common.Password") }}</label>
                            <input type="password" id="Password" v-model.lazy="formData.password" :class="[{ 'input-validation-error': isValidationError('Password') }, 'textbox short']" />
                            <button class="show-password short" @click="formHelper.showPassword('Password'), showPasswordIcon()">
                                <span v-if="isHidden" class="icon fastic-eye-show"></span>
                                <span v-else class="icon fastic-eye-hide"></span>
                            </button>
                            <span class="valid-sign">*</span>
                        </div>
                    </div>
                </div>
                <div class="form-items" data-type="privacy">
                    <div class="item">
                        <div class="checkbox">
                            <input type="checkbox" id="RememberMe" v-model="formData.RememberMe" />
                            <label for="RememberMe">{{ localizer.get("Account.Common.Login_RememberMe") }}</label>
                        </div>
                    </div>
                </div>
            </fieldset>
            <fieldset class="fieldset">
                <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                    <ul>
                        <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                    </ul>
                </div>

                <div class="form-items" data-type="buttons">
                    <div class="item calltoaction">
                        <button id="ButtonSubmit" class="button" @click="submitForm()" :disabled="isLoading"><span class="lable">{{ localizer.get("Account.Common.Login_Button") }}</span></button>
                    </div>
                </div>
                <a :href="routes.Account_PasswordRemind" class="link">{{ localizer.get("Account.Common.Login_ForgotPassword") }}</a>
            </fieldset>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    returnUrl?: string
}>();

const formHelper = FormHelper;
const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const options = ref<any>(null);
const isLoginVisible = ref(false);
const isHidden = ref(true);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    isLoginVisible.value = true;
});

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoading.value = true;

    formData.value.returnUrl = props.returnUrl;

    try {
        await Axios.post(routes.Account_Login, formData.value);

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "account_login");

        window.location.href = props.returnUrl ? props.returnUrl : routes.Home_Home;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}
</script>